import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, MapPin } from 'lucide-react';
export function TestimonialsPrePricing() {
  const testimonials = [{
    name: 'Sandra M.',
    age: 44,
    location: 'Miami',
    text: 'Llevaba 2 años luchando con mi peso después de los 40. En menos de un mes empecé a ver cambios reales en mi abdomen.'
  }, {
    name: 'Lucía R.',
    age: 47,
    location: 'Texas',
    text: 'Por $27 no tenía nada que perder. La guía de sofocos sola ya vale todo.'
  }, {
    name: 'Patricia V.',
    age: 42,
    location: 'California',
    text: 'Descargué todo en segundos y empecé esa misma noche. La claridad del protocolo es increíble.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-343">
      <div className="max-w-5xl mx-auto" data-id="element-344">
        <div className="text-center mb-14" data-id="element-345">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-brand-green" data-id="element-346">
            Lo que Dicen Nuestras Clientas
          </h2>
          <p className="text-lg text-brand-gray/60" data-id="element-347">
            Mujeres reales que ya dieron el paso.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-348">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.5
        }} className="bg-brand-cream p-7 rounded-2xl relative border border-brand-gold/15" data-id="element-349">
              <Quote className="absolute top-5 right-5 w-10 h-10 text-brand-gold/10" data-id="element-350" />

              {/* Stars */}
              <div className="flex gap-0.5 mb-5" data-id="element-351">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-352" />)}
              </div>

              {/* Quote */}
              <p className="text-brand-gray/80 italic leading-relaxed mb-6 relative z-10" data-id="element-353">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="border-t border-brand-gold/15 pt-4" data-id="element-354">
                <p className="font-bold text-brand-green" data-id="element-355">
                  {t.name}, {t.age} años
                </p>
                <div className="flex items-center gap-1.5 mt-1" data-id="element-356">
                  <MapPin className="w-3.5 h-3.5 text-brand-gold" data-id="element-357" />
                  <span className="text-sm text-brand-gray/50" data-id="element-358">
                    {t.location}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}